import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    PAYMENT_THRESHOLD,
    STATIC_ROOT,
    HIDE_ALO,
    HIDE_FLASHING_TICKET,
    HIDE_CLO
} from '../constants';
import { HAS_INSTANT_DISCOUNT } from '../constants/ebon';

import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import SvgComponent from './SvgComponent';
import LocalizedNavLink from './router/LocalizedNavLink';

import './StepsComponent.scss';

class StepsComponent extends React.Component {
    getSteps = () => {
        const {
            i18nOnline,
            i18nOffline,
            i18nEbon,
            i18nInstantDiscount,
            BRAND_NAME_ALT,
            BRAND_NAME_ALT_2,
            isOffline,
            showAloOnly,
            showCloOnly,
            isEbon,
            isInstantDiscount
        } = this.props;

        if (isOffline) {
            return (
                <div className="offline-bloc">
                    {!showCloOnly && !showAloOnly && (
                        <React.Fragment>
                            {(!HIDE_ALO || !HIDE_FLASHING_TICKET) && (
                                <h3>{i18nOffline.FT_TITLE}</h3>
                            )}
                            {!HIDE_FLASHING_TICKET && (
                                <ol className="offline-row">
                                    <li className="cmt-ca-marche-bloc">
                                        <SvgComponent
                                            src={`${STATIC_ROOT}/howitworks/cart.svg`}
                                            alt=""
                                            width="64"
                                            height="64"
                                            aria-hidden="true"
                                            focusable="false"
                                        />
                                        <div className="texte">
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18nOffline.FT_STEP1,
                                                    BRAND_NAME_ALT
                                                )}
                                            </p>
                                        </div>
                                    </li>
                                    <li className="cmt-ca-marche-bloc">
                                        <SvgComponent
                                            src={`${STATIC_ROOT}/howitworks/card.svg`}
                                            alt=""
                                            width="64"
                                            height="64"
                                            aria-hidden="true"
                                            focusable="false"
                                        />
                                        <div className="texte">
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18nOffline.FT_STEP2_1
                                                )}
                                                <LocalizedNavLink
                                                    to="/envoi-ticket"
                                                    title={i18nOffline.FT_STEP2_2}>
                                                    {i18nOffline.FT_STEP2_2}
                                                </LocalizedNavLink>
                                                {i18nOffline.FT_STEP1_3}
                                            </p>
                                        </div>
                                    </li>
                                    <li className="cmt-ca-marche-bloc">
                                        <SvgComponent
                                            src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                                            alt=""
                                            width="64"
                                            height="64"
                                            aria-hidden="true"
                                            focusable="false"
                                        />
                                        <div className="texte">
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18nOffline.FT_STEP3,
                                                    PAYMENT_THRESHOLD
                                                )}
                                            </p>
                                        </div>
                                    </li>
                                </ol>
                            )}
                        </React.Fragment>
                    )}
                    {!HIDE_ALO && !showAloOnly && <h3>{i18nOffline.ALO_TITLE}</h3>}
                    {!HIDE_ALO && (
                        <ol className="offline-row">
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/cart.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.ALO_STEP1,
                                            BRAND_NAME_ALT
                                        )}
                                    </p>
                                </div>
                            </li>
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/card.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.ALO_STEP2,
                                            BRAND_NAME_ALT
                                        )}
                                    </p>
                                </div>
                            </li>
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.ALO_STEP3,
                                            PAYMENT_THRESHOLD
                                        )}
                                    </p>
                                </div>
                            </li>
                        </ol>
                    )}
                    {!HIDE_CLO && (
                        <ol className="offline-row">
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/cart.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>{convertHtmlToReactDomWithParams(i18nOffline.CLO_STEP1)}</p>
                                </div>
                            </li>
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/card.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>{convertHtmlToReactDomWithParams(i18nOffline.CLO_STEP2)}</p>
                                </div>
                            </li>
                            <li className="cmt-ca-marche-bloc">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                                    alt=""
                                    width="64"
                                    height="64"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.CLO_STEP3,
                                            PAYMENT_THRESHOLD
                                        )}
                                    </p>
                                </div>
                            </li>
                        </ol>
                    )}
                </div>
            );
        } else if (isEbon) {
            return (
                <ol className="list">
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/cart.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP1, BRAND_NAME_ALT)}</p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/card.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP2)}</p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            {HAS_INSTANT_DISCOUNT ? (
                                <p>
                                    {convertHtmlToReactDomWithParams(
                                        i18nEbon.STEP3_INSTANT_DISCOUNT
                                    )}
                                </p>
                            ) : (
                                <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP3)}</p>
                            )}
                        </div>
                    </li>
                </ol>
            );
        } else if (isInstantDiscount) {
            return (
                <ol className="list">
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/cart.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18nInstantDiscount.STEP1,
                                    BRAND_NAME_ALT
                                )}
                            </p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/card.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nInstantDiscount.STEP2)}</p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nInstantDiscount.STEP3)}</p>
                        </div>
                    </li>
                </ol>
            );
        } else {
            return (
                <ol className="list">
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/cart.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOnline.STEP1, BRAND_NAME_ALT)}
                            </p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/card.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nOnline.STEP2)}</p>
                        </div>
                    </li>
                    <li className="cmt-ca-marche-bloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/howitworks/jackpot.svg`}
                            alt=""
                            width="64"
                            height="64"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18nOnline.STEP3,
                                    BRAND_NAME_ALT_2
                                )}
                            </p>
                        </div>
                    </li>
                </ol>
            );
        }
    };

    render() {
        return (
            <section className="steps">
                <div className="wrapper">{this.getSteps()}</div>
            </section>
        );
    }
}

StepsComponent.propTypes = {
    isOffline: PropTypes.bool,
    showAloOnly: PropTypes.bool,
    showCloOnly: PropTypes.bool,
    isEbon: PropTypes.bool,
    isInstantDiscount: PropTypes.bool
};

const mapStoreToProps = state => ({
    i18nOnline: state.i18n.feature.aide.HOW_IT_WORKS.ONLINE,
    i18nOffline: state.i18n.feature.aide.HOW_IT_WORKS.OFFLINE,
    i18nEbon: state.i18n.feature.aide.HOW_IT_WORKS.EBON,
    i18nInstantDiscount: state.i18n.feature.aide.HOW_IT_WORKS.INSTANT_DISCOUNT,
    BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT,
    BRAND_NAME_ALT_2: state.i18n.common.BRAND_NAME_ALT_2
});

export default connect(mapStoreToProps)(StepsComponent);



// WEBPACK FOOTER //
// ./src/components/StepsComponent.js